(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('UserActivationSearch', UserActivationSearch);

    UserActivationSearch.$inject = ['$resource'];

    function UserActivationSearch($resource) {
        var resourceUrl =  'api/_search/user-activations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
